var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#252342",
    d: "M28.514.578H7.832c-1.958.002-3.836.781-5.22 2.166S.448 6.006.445 7.964v17.727a7.397 7.397 0 0 0 7.386 7.386h20.682a7.397 7.397 0 0 0 7.386-7.386V7.964A7.395 7.395 0 0 0 28.514.578M7.832 3.533h20.682A4.43 4.43 0 0 1 32.62 6.32L21.307 17.635a4.44 4.44 0 0 1-6.27 0L3.725 6.32a4.43 4.43 0 0 1 4.107-2.788zm20.682 26.591H7.832A4.43 4.43 0 0 1 3.4 25.692V10.18l9.549 9.543a7.4 7.4 0 0 0 10.448 0l9.549-9.543v15.511a4.43 4.43 0 0 1-4.432 4.432z"
  })));
};
export default SvgEnvelope;